import * as React from "react";
import { Button, notification, Popconfirm, Row, Col } from "antd";
import { CreditCardRegistrationFormHandler } from "../CreditCardRegistrationFormHandler";
import { ICreditCardRegistrationDto } from "Core/Api/Payment/Api";
import CreditCardRegisteredList from "../CreditCardRegisteredList";
import { Route, RouteComponentProps, withRouter } from "react-router-dom";
import Form, { FormComponentProps } from "antd/lib/form";
import NotificationUtility from "Core/NotificationUtility";

export interface Props extends FormComponentProps, RouteComponentProps {
    children?: React.ReactNode
    // cardDetails: Array<ICreditCardRegistrationDto>,
    cardDetails: ICreditCardRegistrationDto,
    regId: number,
    deleted(): any;
}

export interface State {
}

class DeleteCreditCardWithoutRouterAndForm extends React.Component<Props, State> {
    creditCardRegistrationFormHandler: CreditCardRegistrationFormHandler;

    constructor(props: Props) {
        super(props)
        this.creditCardRegistrationFormHandler = new CreditCardRegistrationFormHandler(props);
        // this.DeleteCard = this.DeleteCard.bind(this);
        this.onDelete = this.onDelete.bind(this);

        this.state = {
        }
    }

    onDelete = () => {
        this.props.deleted();
    }

    DeleteCard = () => {
        if (this.props.cardDetails !== undefined) {
            var i;
            var cardIdDel
            var cardDetails = this.props.cardDetails;
            for (i in cardDetails) {
                //maybe do some more checks, like card type with first & last digits
                if (this.props.regId === cardDetails.id) {
                    cardIdDel = cardDetails.id;
                };
            };
        };

        if (cardIdDel !== undefined) {
            this.creditCardRegistrationFormHandler
                .DeleteCreditCard(cardIdDel)
                .then(() => {
                    NotificationUtility.success('Card Deleted',
                        `Card ending with ${cardDetails.cardNumberLastFourDigits} has successfully been deleted.`,
                        10,
                        true
                    );
                    this.onDelete();
                })
                .catch(x => {
                    NotificationUtility.error('Failed to Delete Card', x.message, 30, true);
                });
        }
    }


    render() {
        return (
            <Row type="flex">
                <Col span={24}>
                    <Popconfirm
                        title="Are you sure you want to Delete this Card?"
                        onConfirm={this.DeleteCard}
                        onCancel={() => { }}
                        okText="Yes, I am sure"
                        cancelText="No, Do not Delete"
                    >
                        <Button size="large" style={{ backgroundColor: '#FF6232', color: 'white', marginRight: 1, marginLeft: 1, marginTop: 5, width: 120 }} icon="delete" >Delete</Button>
                    </Popconfirm>
                </Col>
            </Row>
        )
    }
}


const DeleteCreditCardWithoutRouter = Form.create<Props>({
    name: 'UpdateUserProfileForm',
})(DeleteCreditCardWithoutRouterAndForm);

const DeleteCreditCard = withRouter(DeleteCreditCardWithoutRouter);

export default DeleteCreditCard;